<template>
  <div class="maincont" id="detail_realtime">
    <div id="charts">
      <div class="ef--inner">
        <div id="realtime">
          <h2>電力リアルタイム</h2>

          <a
            href="javascript:void(0);"
            class="dlbtn"
            @click="downloadDialog = true"
          >帳票ダウンロード</a>

          <p class="subttl">電力リアルタイムグラフ</p>
          <dl class="chart_display_date">
            <dt>表示日時</dt>
            <dd>
              <select id="monitoring_list_from" v-model="getStartDate">
                <option
                  v-bind:value="option.value"
                  v-for="(option, index) in dateList"
                  v-bind:key="index"
                  >{{ option.text }}</option
                >
              </select>
            </dd>
            <span>~</span>
            <dd>
              <select id="monitoring_list_to" v-model="getEndDate">
                <option
                  v-bind:value="option.value"
                  v-for="(option, index) in dateList"
                  v-bind:key="index"
                  >{{ option.text }}</option
                >
              </select>
            </dd>
          </dl>

          <div class="chart_wrap">
            <div id="realtime_legend" class="legend"></div>
            <div class="container">
              <p class="label_left">(kW)</p>
              <p class="label_bottom">(年月日)</p>
              <p id="chart_month"></p>
              <canvas id="realtime_canvas"></canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
    <download-dialog
      @close="downloadDialog=false"
      v-if="downloadDialog"
      :account="this.$store.state.childID"
      :loginType="this.$store.state.loginType"
      :start=this.startDate
      :end=this.endDate
    ></download-dialog>
  </div>  
</template>

<script>
/* eslint-disable */
// import Chart from "chart.js";
// import $ from "jquery";

import moment from "moment";
import DownloadDialog from "../components/PowerMeasureDataDownloadDialog.vue";
export default {
  name: "realtime",
  components: {
    DownloadDialog
  },
  data: function() {
    return {
      downloadDialog: false,
      startDate: "",
      endDate: "",
      dateList: [],
      chart: null
    };
  },
  computed: {
    getStartDate: {
      get: function() {
        return this.startDate;
      },
      // setter 関数
      set: function(newValue) {
        // console.log(this.endDate);
        this.startDate = "";
        this.startDate = newValue <= this.endDate ? newValue : this.endDate;
        console.log(this.startDate);
        this.getRealtime(this.startDate, this.endDate);
      }
    },
    getEndDate: {
      get: function() {
        return this.endDate;
      },
      // setter 関数
      set: function(newValue) {
        // console.log(this.startDate);
        this.endDate = "";
        this.endDate = newValue >= this.startDate ? newValue : this.startDate;
        console.log(this.endDate);
        this.getRealtime(this.startDate, this.endDate);
      }
    }
  },
  methods: {
    getRealtime(startDate, endDate) {
      console.log("getRealtime");

      const startDateTime = startDate + " 00:00:00";
      const endDateTime = moment
        .utc(endDate, "YYYY/MM/DD")
        .add(1, "days")
        .format("YYYY/MM/DD 00:00:00");
      console.log(startDateTime);
      console.log(endDateTime);

      let params = new URLSearchParams();
      var json = {
        start_datetime: startDateTime,
        end_datetime: endDateTime
      };
      this.$axios
        .post(`/srv/api/realtime/${this.$store.state.childID}`, json, {
          withCredentials: true
        })
        .then(response => {
          console.log(response.data);
          this.drawGraph(response.data);
        })
        .catch(error => {
          console.log(error);
        });
    },
    drawGraph: function(data) {
      console.log("drawGraph");
      var measureInstrument = data.measure_instrument;
      const self = this;
      const timetable = this.createRealtimeTimeTable(
        this.startDate,
        this.endDate,
        measureInstrument
      );
      console.log(data);

      var realtime_power = Array(timetable.length);
      var control_power = Array(timetable.length);

      for (let index = 0; index < timetable.length; index++) {
        const element = timetable[index];
        const obj = data.realtime.filter(obj => obj.datetime == element);
        realtime_power[index] = obj.length > 0 ? obj[0].power : null;
        if (data.air_conditioner_control_flg) control_power[index] = obj.length > 0 ? obj[0].control_power : null;
      }

      var realtime_date = this.createRealtimeLabel(
        this.startDate,
        this.endDate,
        measureInstrument
      );
      console.log(realtime_date);

      var realtime_kw_min = 0; //kWの最小値
      var realtime_kw_max =
        Math.ceil((Math.max.apply(null, realtime_power) + 10) / 10) * 10; //kWの最大値
      var realtime_kw_step = 10; //kWの表示間隔

      var a = {
        labels: realtime_date,
        datasets: [
          {
            type: "line",
            data: control_power,
            borderColor: "rgba(255,0,0,1)",
            fill: false,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 4,
            pointHitRadius: 10
          },
          {
            type: "line",
            label: "電力",
            data: realtime_power,
            borderColor: "rgba(50,100,255,1.0)",
            fill: false,
            yAxisID: "y-axis-1",
            pointRadius: 0,
            pointHoverRadius: 4,
            pointHitRadius: 10
          }
        ]
      };
      var b = {
        responsive: true,
        maintainAspectRatio: false,
        legend: false,
        legendCallback: function(e) {
          var f = [];
          f.push('<ul class="' + e.id + '-legend">');
          for (var d = e.data.datasets.length - 1; d > 0; d--) {
            f.push("<li><span>");
            if (e.data.datasets[d].label) {
              f.push(e.data.datasets[d].label);
            }
            f.push("</span></li>");
          }
          f.push("</ul>");
          return f.join("");
        },
        elements: {
          line: {
            tension: 0
          },
          point: {
            radius: 0
          }
        },
        scales: {
          xAxes: [
            {
              ticks: {
                maxRotation: 0,
                minRotation: 0,
                autoSkip: false
              },
              gridLines: {
                display: false,
                drawOnChartArea: false
              }
            }
          ],
          yAxes: [
            {
              id: "y-axis-1",
              type: "linear",
              position: "left",
              ticks: {
                max: realtime_kw_max,
                min: realtime_kw_min,
                stepSize: realtime_kw_step
              }
            }
          ]
        },
        tooltips: {
          callbacks: {
            title: function(tooltipItem, data) {
              var dataIndex = tooltipItem[0].datasetIndex;
              if (dataIndex == 0) { // デマンド制御あり
                return "デマンド制御あり";
              }
            },
            label: function(tooltipItem, data) {
              const startDate = moment.utc(self.startDate, "YYYY/MM/DD");
              var minute = 1;
              if (measureInstrument == 1) {
                minute = 5;
              }
              startDate.add(minute * tooltipItem.index, "minute");
              if (tooltipItem.datasetIndex == 1) {
                const str = `日時:${startDate.format(
                "MM/DD HH:mm"
                )}  電力:${tooltipItem.yLabel}kW`;
                return str;
              }
            }
          }
        }
      };
      // $(function() {
      // var c;
      // $(window).on("load", function() {
      if (this.chart != null) {
        this.chart.destroy();
      }
      this.chart = new Chart(
        document.getElementById("realtime_canvas").getContext("2d"),
        {
          type: "bar",
          data: a,
          options: b
        }
      );
      $("#realtime_legend").html(this.chart.generateLegend());
      // });

      // });
    }
  },
  mounted: function() {
    //
    this.dateList = this.getRealtimeDateOptions();
    this.startDate = this.dateList[this.dateList.length - 1].value;
    this.endDate = this.dateList[this.dateList.length - 1].value;
    this.getRealtime(this.startDate, this.endDate);
  }
};
</script>

